import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, ChevronDown } from 'lucide-react';
import ZheltaLogo from '../ZheltaLogo';
import { useAuth } from '../../context/AuthContext';

/* Top header for the LMS portal. Mirrors the GCU teal/dark bar pattern but in
 * ZHELTA's dark + gold theme. Shows portal label, logged-in email, sign-out. */
export default function PortalTopBar({ portalLabel = 'STUDENT ACCESS' }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 w-full">
      {/* Welcome strip */}
      <div className="bg-[#0e0e10] border-b border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 py-2 flex items-center justify-end gap-4 text-[12px]">
          <span className="text-white/70">
            Welcome <span className="text-white font-semibold">{user?.email}</span>
          </span>
          <button
            type="button"
            onClick={async () => { await logout(); navigate('/academy/login'); }}
            data-testid="portal-signout"
            className="inline-flex items-center gap-1.5 text-[#f5a623] hover:text-white transition-colors font-semibold"
          >
            <LogOut className="w-3.5 h-3.5" /> Sign out
          </button>
        </div>
      </div>

      {/* Brand bar */}
      <div
        className="border-b-4"
        style={{
          background: 'linear-gradient(135deg,#1a1a1f 0%,#0e0e10 100%)',
          borderColor: '#c9a227',
        }}
      >
        <div className="max-w-[1440px] mx-auto px-6 h-[78px] flex items-center justify-between">
          <Link to="/academy/dashboard" className="flex items-center gap-3">
            <ZheltaLogo size={42} />
            <div className="flex flex-col leading-none">
              <span className="text-[20px] font-extrabold tracking-[0.18em] text-white">ZHELTA</span>
              <span className="text-[10px] font-semibold tracking-[0.26em] text-[#f5a623]">ACADEMY</span>
            </div>
          </Link>
          <span className="hidden md:block text-[14px] font-bold tracking-[0.22em] text-white/90 uppercase">
            {portalLabel}
          </span>
          <div className="flex items-center gap-2">
            <span className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[12px] text-white/80">
              {user?.name || user?.email}
              <ChevronDown className="w-3.5 h-3.5 text-white/50" />
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
